import React from "react";
import Link from "next/link";
import { Button } from "../../../shadcn/components/ui/button";
import { Separator } from "../../../shadcn/components/ui/separator";
import SellerAssetTransferEventForm from "./SellerAssetTransferEventForm";

/**
 * Seller “create asset” — ARC onboarding shortcuts + asset-transfer event form.
 * Used from the seller app; routes like /assets and /assets/create are host-specific.
 */
export default function CreateAssetPage() {
  return (
    <div className="flex w-full min-w-0 max-w-full flex-1 flex-col bg-[#F8F8F8]">
      <div className="box-border w-full min-w-0 max-w-full px-4 py-6 lg:px-8">
        <nav className="text-sm text-muted-foreground mb-4 flex items-center gap-2">
          <Button variant="link" className="h-auto p-0 text-[#666]" asChild>
            <Link href="/assets">All Assets</Link>
          </Button>
          <span className="text-[#ccc]">/</span>
          <span className="text-foreground">Create asset</span>
        </nav>

        <div className="flex flex-col sm:flex-row flex-wrap gap-3 mb-6">
          <Button type="button" onClick={() => {}}>
            Create ARC onboarding
          </Button>
          <Button type="button" variant="secondary" onClick={() => {}}>
            Create account
          </Button>
          <Button type="button" variant="secondary" onClick={() => {}}>
            Create account pool
          </Button>
          <Button type="button" variant="outline" onClick={() => {}}>
            Create events for asset
          </Button>
        </div>

        <Separator className="mb-6" />
        <SellerAssetTransferEventForm />
      </div>
    </div>
  );
}
